import React, {createContext, useContext, useReducer} from 'react';


export const DataLayerContext = createContext();

export const DataLayer = ({initialState, reducer, children}) => (
    <DataLayerContext.Provider value={useReducer(reducer, initialState)}>
        {children}
    </DataLayerContext.Provider>
)

// pull information from the data layer
export const useDataLayerValue = () => useContext(DataLayerContext);